/**
 * Takes in a function and returns a new function that ensures that the given function does not run more than once
 * in a given stack frame.
 */
export const preventNestedFunctionCalls = <T extends (...args: any[]) => void>(functionToExecute: T): T => {
  let isAlreadyExecuting: boolean = false;

  return function wrappedFunction(...args: any[]): void {
    if (!isAlreadyExecuting) {
      isAlreadyExecuting = true;
      functionToExecute(...args);
      isAlreadyExecuting = false;
    }
  } as T;
};
